export default {
  scoreCard: {
    score: "Score",
    copyToast: "Discount code copied."
  },
  infoCard: {
    accountSetting: "Account Settings",
    deposit: "Deposit",
    withdrawal: "Withdrawal",
    totalAssetsValue: "Total Asset Value",
    profitOrLossAmount: "Total Profit (Loss) Amount",
    totalAssetsValueMain: "Main Balance",
    profitOrLossMain: "Spot Balance"
  },
  referralCard: {
    introduceToFriends: "Refer to Friends",
    inviteGetExcoin: "Invite friends, get Excoin",
    referralCode: "Referral Code",
    referralLink: "Referral Link",
    referralCodeCopied: "Referral code copied",
    referralLinkCopied: "Referral link copied"
  },
  pmCard: {
    tradePerfectMoney: "Buy/Sell Perfect Money",
    perfectMoneyDesc:
      "In this section, you can buy and sell your Perfect Money."
  },
  scoresCard: {
    scoresTitle: "Excoino Coolak Festival",
    scoresDescription:
      "Your total points in the Excoino Coolak Festival until the beginning of today"
  },
  authorizationCard: {
    authorizationNotCompleted: "Your identity verification is not completed",
    completeAuthDesc:
      "By completing your identity verification, you can deposit and withdraw Rial.",
    completeAuthorization: "Complete Identity Verification"
  },
  marketBanner: {
    newLabel: "New",
    excoinoTrader: "Excoino Market",
    market: "Market",
    tradeCurrenciesWithExcoino:
      "Excoino Market, the advanced cryptocurrency trading market"
  },
  transactionsCard: {
    lastTransactions: "Last Transactions",
    didNoneTransactions: "You have not made any transactions",
    fromPrice: "From",
    toPrice: "To"
  },
  ticketsCard: {
    lastTickets: "Last Tickets",
    noMessages: "You have no messages"
  },
  currenciesCard: {
    lastListedCryptos: "Last Listed Cryptos",
    lastAddedCryptos: "The latest cryptocurrencies added to Excoino."
  },
  discountCard: {
    title: "Gift Code",
    description: "Enter the desired gift code in the box below.",
    buttonTitle: "Apply",
    inputPlaceholder: "Gift Code",
    tnxForSupportText: "Thank you for your support of Excoino",
    friendshipText: "This friendship continues",
    goToWalletText: "Go to Wallet",
    understoodBtn: "Got it",
    yourCodeConfirmed:
      "Your desired code has been applied, the following amount has been invested in StakingPage.",
    priceAdded:
      "To appreciate your support of Excoino, the following amount has been added to your wallet."
  },
  guideCard: {
    pannelGuideTitle: "Excoino Panel Guide",
    pannelGuideText: "If you need guidance on using the Excoino panel"
  }
};
